import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormuleConfigRoutingModule } from './formule-config-routing.module';
import { FormuleConfigComponent } from './formule-config.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularmaterialModule } from '../../modules/angular-material-module';
import { SharedModule } from 'src/app/modules/shared.module';
import { FormuleConfigAddComponent } from './formule-config-add/formule-config-add.component';
import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';


@NgModule({
  declarations: [
    FormuleConfigComponent,
    FormuleConfigAddComponent
  ],
  imports: [
    CommonModule,
    AngularmaterialModule,
    SharedModule,
    FormuleConfigRoutingModule
  ],
  providers: [
    {provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher}
  ]
})
export class FormuleConfigModule { }
